import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "../../../global/global";

@Component({
  selector: "app-add-post",
  templateUrl: "./add-post.component.html",
  styleUrls: ["./add-post.component.css"]
})
export class AddPostComponent implements OnInit {
  isStepper : number = 1;
  isSteps;
  currentPostId;
  jobPostId ;
  filledData: any;
  addDataFlow: any;
  isAdd = false;
  isReplicatingJob = false;
  isStepperLocal=0
  constructor(private router: Router,private api: AdminService,private route: ActivatedRoute) { }

  ngOnInit(): void { 
    this.isAdd = this.router.url.toString().includes("/add")
    this.route.queryParams
      .subscribe(params => { 
      this.jobPostId = params.jobId; 
      if (params.isStepper != undefined && params.isStepper != null){
      this.isStepper = params.isStepper || 0
      this.isStepperLocal = params.isStepper || 0
      const params1 = { ...this.route.snapshot.queryParams };
      delete params1.isStepper;
      this.router.navigate([], { queryParams: params1 });
      }
      }
    );
    
    if (this.jobPostId != undefined && this.jobPostId != null){
      this.currentPostId = this.jobPostId
    } else if (this.currentPostId != undefined && this.currentPostId != "" && this.currentPostId != null){
      this.currentPostId = localStorage.getItem("currentPostId")
    }
    if (this.currentPostId != undefined && this.currentPostId != "" && this.currentPostId != null) {
      this.getDetail();
    }
  }
  getDetail(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getJobs+"/"+this.currentPostId)
    .subscribe(async (res) => {
      this.filledData = res.data
      if (this.isAdd && this.jobPostId != undefined) {
        this.jobPostId = undefined;
        delete this.filledData?.JobPost?.id
      }
     if(this.isStepperLocal==0){
        this.isStepper = this.filledData.JobPost.steps + 1;
      }
    })
  }
  
  catchFile(event) {
    localStorage.setItem("currentPostId",event.data?.id);
    this.currentPostId = event.data?.id;
    this.isStepperLocal=0
    this.getDetail();
  }
  onChangeDetected(event) {
    console.log(event,"event");
    
  }
  stepChanged(event) {
    console.log(event, "stepper");
    this.isStepper = event.step
  }
  next() {
    this.isStepper += 1;
  }
  back() {
    this.isStepper -= 1;
  }
}
